(function ($) {
    $(function () {
        $("[data-background-img]").each((_, e) => {
            const url = $(e).data("background-img");
            if (url?.length > 0)
                $(e).css('background-image', `url('${url}')`)
        })
    })
})(jQuery);
